import { Navigation, Pagination, Thumbs, FreeMode } from "swiper";
import { breakPoint } from "./sliderBreakPoint";

export const thumbsConfig = (slidesPerView, vertical, type) => {
  const config = {
    modules: [FreeMode],
    slidesPerView: slidesPerView,
    watchSlidesProgress: true,
    freeMode: true,
    breakpoints: breakPoint(type),
  }
  // eslint-disable-next-line no-unused-expressions
  vertical && (config.direction = "vertical");

  return config;
}

export const principalConfig = (thumbnails, slider, index) => {
  const config = {
    modules: [Navigation, Pagination, Thumbs],
    spaceBetween: 12,
    initialSlide: Number(index),
    thumbs: {
      swiper: thumbnails,
    },
    navigation: {
      nextEl: `.swiper-button-next${slider}`,
      prevEl: `.swiper-button-prev${slider}`,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    loop: true,
  }

  return config;
}
